import BaseComponent from "@js/components/base_component.jsx";

import EuiUsersForm from "@js/components/eui/users/form.jsx";

class EuiUsersShow extends BaseComponent {

  render() {
    return (
      <EuiUsersForm { ...this.props } editing={ false } />
    );
  }

}

export default EuiUsersShow;
